import {BrowserModule} from '@angular/platform-browser';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule, NgModuleFactoryLoader, SystemJsNgModuleLoader} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {CoreModule} from './core/core.module';
import {ReactiveFormsModule} from '@angular/forms';
import {KeycloakService} from './core/auth/keycloak.service';
import {AuthGuardService} from './core/auth-guard/auth-guard.service';
import {RouterModule} from '@angular/router';
import {OutwardChecksComponent} from './modules/outward-checks/outward-checks.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {ModulesComponent} from './modules/modules/modules.component';
import {AllModuleModule} from './modules/all-module.module';
import { CalendarComponent } from './calendar/calendar.component';
import { ArchiveComponent } from './archive/archive.component';
import { HelpComponent } from './help/help.component';
import { ConfigurationsComponent } from './configurations/configurations.component';

@NgModule({
    declarations: [
        AppComponent,
        DashboardComponent,
        CalendarComponent,
        ArchiveComponent,
        HelpComponent,
        ConfigurationsComponent,

    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        CoreModule,
        ReactiveFormsModule,
        BrowserModule,
        RouterModule,
        AllModuleModule
    ],

    providers: [
        // KeycloakService,
        // AuthGuardService,
        // {provide: NgModuleFactoryLoader, useClass: SystemJsNgModuleLoader}
    ],
    bootstrap: [AppComponent]
})
export class AppModule {


}
